import type { StrictMerge } from '@noths/polaris-dev-ts-recipes';

export type DeliveryByEventName =
  | 'valentines_day'
  | 'mothers_day'
  | 'easter'
  | 'fathers_day'
  | 'halloween'
  | 'christmas';

const deliveryByEventNamesMap: Record<DeliveryByEventName, undefined> = {
  valentines_day: undefined,
  mothers_day: undefined,
  easter: undefined,
  fathers_day: undefined,
  halloween: undefined,
  christmas: undefined,
};

export const deliveryByEventNames = Object.keys(deliveryByEventNamesMap);

interface DeliveryByEventAttrs {
  name: string;
  prefix: 'Get' | 'Arrives';
}

type DeliveryByEventDisplayNames = StrictMerge<
  Record<DeliveryByEventName, DeliveryByEventAttrs>,
  {
    christmas: {
      name: 'Christmas';
      prefix: 'Arrives';
    };
    easter: {
      name: 'Easter';
      prefix: 'Get';
    };
    fathers_day: {
      name: "Father's day";
      prefix: 'Get';
    };
    halloween: {
      name: 'Halloween';
      prefix: 'Get';
    };
    mothers_day: {
      name: "Mother's day";
      prefix: 'Get';
    };
    valentines_day: {
      name: "Valentine's day";
      prefix: 'Get';
    };
  }
>;

type DeliveryByEventDisplayName = DeliveryByEventDisplayNames[keyof DeliveryByEventDisplayNames];

export interface DeliveryByEvent {
  arriveByEvent: boolean;
  eventName: DeliveryByEventName;
  lastDeliveryBy: string;
}

const DELIVERY_EVENT: DeliveryByEventDisplayNames = {
  easter: {
    prefix: 'Get',
    name: 'Easter',
  },
  fathers_day: {
    prefix: 'Get',
    name: "Father's day",
  },
  halloween: {
    prefix: 'Get',
    name: 'Halloween',
  },
  mothers_day: {
    prefix: 'Get',
    name: "Mother's day",
  },
  valentines_day: {
    prefix: 'Get',
    name: "Valentine's day",
  },
  christmas: {
    prefix: 'Arrives',
    name: 'Christmas',
  },
};

export const getDeliveryByEventName = (
  deliveryEvent: DeliveryByEventName,
): DeliveryByEventDisplayName => DELIVERY_EVENT[deliveryEvent];

export const getDeliveryByEventLabel = (deliveryEvent: DeliveryByEventName): string => {
  const eventDetails = getDeliveryByEventName(deliveryEvent);

  return eventDetails ? `${eventDetails.prefix} by ${eventDetails.name}` : '';
};
